export const appendImageVersion = (url?: string, version?: string | number) => {
  if (!url || !version) return url || '';

  try {
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.set('v', String(version));
    return parsedUrl.toString();
  } catch (error) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${encodeURIComponent(String(version))}`;
  }
};
